// Lazy load function
const lazyLoad = (file) => () =>
    import(
      /* webpackChunkName: "[request]" */ `@/views/products/grid-reports/${file}.vue`
    );

export default [

    {
        path: "/stock-summary",
        name: "stock-summary",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "StockSummary",
        },
        components: {
            content: lazyLoad('product-stock-summary'),
        },
    },

    {
        path: "/item-movements",
        name: "item-movements",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ItemMovements",
        },
        components: {
            content: lazyLoad('product-item-movements'),
        },
    },

    {
        path: "/batch-movements",
        name: "batch-movements",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ItemMovements",
        },
        components: {
            content: lazyLoad('product-batch-movements'),
        },
    },


    {
        path: "/report-product-batch-stock",
        name: "report-product-batch-stock",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ReportGridProductBatchStock",
        },
        components: {
            content: lazyLoad('product-batch-stock'),
        },
    },
];
